module.exports = __webpack_public_path__ + "img/LP – 1.90c40565.svg";